import { ENUM_PAGES } from '../core/helpers/enums';

export interface MenuItem {
    translationKey: string;
    link: string;
    keys: string[];
    subItems?: MenuItem[];
    icon?: string;
    label?: string;
}

export const MENU_ITEMS: MenuItem[] = [
    {
        translationKey: 'painel',
        link: '',
        keys: [ENUM_PAGES.painelKPI, ENUM_PAGES.painelGeorreferencia],
        icon: 'icon-minus',
        subItems: [
            {
                translationKey: 'dashboard',
                link: '',
                keys: [ENUM_PAGES.painelKPI],
                icon: 'icon-menu-dashboard',
            },
            {
                translationKey: 'projects',
                link: '/painel/projetos',
                keys: [ENUM_PAGES.painelProjetosTodos],
                icon: 'icon-airplay',
            },
            {
                translationKey: 'georreferencia',
                link: '/painel/georreferencia',
                keys: [ENUM_PAGES.painelGeorreferencia],
                icon: 'icon-map-pin',
            },
            // {
            //     translationKey: 'Scrumboard',
            //     link: '/painel/scrumboard',
            //     keys: [ENUM_PAGES.cadastroTipoDeUsuario],
            //     icon: 'icon-notes-edit',
            // },
        ],
    },
    {
        translationKey: 'register',
        link: '',
        keys: [
            ENUM_PAGES.cadastroGrupoFluxo,
            ENUM_PAGES.cadastroProjetos,
            ENUM_PAGES.cadastroSecretarias,
            ENUM_PAGES.cadastroPastas,
            ENUM_PAGES.cadastroTipoDeUsuario,
        ],
        icon: 'icon-minus',
        subItems: [
            {
                translationKey: 'flow-group',
                link: '/cadastro/grupo-de-fluxo',
                keys: [ENUM_PAGES.cadastroGrupoFluxo],
                icon: 'icon-menu-elements',
            },
            {
                translationKey: 'projects',
                link: '/cadastro/projetos',
                keys: [ENUM_PAGES.cadastroProjetos],
                icon: 'icon-menu-tables',
            },
            {
                translationKey: 'offices',
                link: '/cadastro/secretarias',
                keys: [ENUM_PAGES.cadastroSecretarias],
                icon: 'icon-box',
            },
            {
                translationKey: 'folders',
                link: '/cadastro/pastas',
                keys: [ENUM_PAGES.cadastroPastas],
                icon: 'icon-folder',
            },
            {
                translationKey: 'kind-users',
                link: '/cadastro/tipo-usuario',
                keys: [ENUM_PAGES.cadastroTipoDeUsuario],
                icon: 'icon-user',
            },
            {
                translationKey: 'kind-flow-group',
                link: '/cadastro/tipo-grupo-fluxo',
                keys: [ENUM_PAGES.cadastroTipoDeUsuario],
                icon: 'icon-tag',
            },
        ],
    },
    {
        translationKey: 'management',
        link: '',
        keys: [ENUM_PAGES.cadastroTipoDeUsuario],
        icon: 'icon-minus',
        subItems: [
            {
                translationKey: 'users',
                link: '/gerenciamento/usuarios',
                keys: [ENUM_PAGES.cadastroTipoDeUsuario],
                icon: 'icon-user',
            },
        ],
    },
];
